import Modal from "./Modal";
export * from "./Modal";
export * from "./interface";
export default Modal;
